export default "__VITE_ASSET__Cqd6j61G__"